import { render, staticRenderFns } from "./NoCardDecks.vue?vue&type=template&id=70d37fcb&scoped=true&"
import script from "./NoCardDecks.vue?vue&type=script&lang=js&"
export * from "./NoCardDecks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d37fcb",
  null
  
)

export default component.exports